"use client"

import { useState } from "react"
import { Trophy } from "lucide-react"
import { NineSliceButton } from "@/components/ui/nine-slice-button"
import { useViewportHeight } from "@/hooks/use-viewport-height"
import { GameStats } from "@/components/game-over/game-stats"
import { LeaderboardModal } from "@/components/leaderboard/leaderboard-modal"

interface GameOverScreenProps {
  level: number
  score: number
  onRestart: () => void
}

export const GameOverScreen = ({ level, score, onRestart }: GameOverScreenProps) => {
  const viewportHeight = useViewportHeight()
  const [isLeaderboardOpen, setIsLeaderboardOpen] = useState(false)

  return (
    <div
      id="game-over-screen"
      className="absolute inset-0 flex flex-col z-50"
      style={{
        height: viewportHeight ? `${viewportHeight}px` : "100dvh",
        backgroundColor: "hsl(var(--game-surface-overlay))",
      }}
    >
      <div className="absolute top-0 left-0 right-0 flex justify-center pt-4">
        <GameStats level={level} score={score} className="text-xl text-muted-foreground space-y-2" />
      </div>

      <div className="flex-1 flex flex-col items-center justify-center">
        <img
          src="/images/logo-defeated.png"
          alt="Defeated"
          width={400}
          height={200}
          className="mx-auto mb-4"
          style={{ imageRendering: "auto" }}
        />
        <NineSliceButton id="restart-button" onClick={() => onRestart()} className="text-lg">
          <span className="text-black">Restart</span>
        </NineSliceButton>
        <button
          id="game-over-leaderboard-button"
          onClick={() => setIsLeaderboardOpen(true)}
          className="mt-4 flex items-center gap-2 text-muted-foreground hover:text-foreground transition text-sm"
        >
          <Trophy size={16} />
          Leaderboard
        </button>
      </div>

      <LeaderboardModal isOpen={isLeaderboardOpen} onClose={() => setIsLeaderboardOpen(false)} />
    </div>
  )
}
